import { render } from "./ppk.vue?vue&type=template&id=b4bb6fa8"
import script from "./ppk.vue?vue&type=script&lang=js"
export * from "./ppk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__